import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './UpcomingSets.css';

/**
 * Countdown to upcoming Pokemon TCG sets in the active series. Pulls from the
 * existing `series-showcase` endpoint and renders only sets where
 * isUpcoming === true. Hidden when there's nothing to count down to so the
 * homepage doesn't display an empty section.
 */
export default function UpcomingSets({ series = 'Mega Evolution' }) {
  const [sets, setSets] = useState([]);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    fetch(`/api/categories/series-showcase?series=${encodeURIComponent(series)}`)
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        const upcoming = (data?.sets || []).filter(s => s.isUpcoming);
        setSets(upcoming);
      })
      .catch(() => {});
  }, [series]);

  useEffect(() => {
    if (!sets.length) return;
    const t = setInterval(() => setNow(Date.now()), 60_000);
    return () => clearInterval(t);
  }, [sets.length]);

  if (!sets.length) return null;

  return (
    <section className="upcoming-sets">
      <div className="section-header">
        <h2>Coming soon — {series}</h2>
        <Link to="/pre-orders" className="section-header__link">All pre-orders →</Link>
      </div>
      <div className="upcoming-sets__grid">
        {sets.map(s => {
          const releaseTs = Date.parse(String(s.releaseDate || '').replace(/\//g, '-'));
          const ms = Number.isFinite(releaseTs) ? releaseTs - now : 0;
          return (
            <article key={s.id} className="upcoming-set-card">
              {s.logo && <img src={s.logo} alt="" className="upcoming-set-card__logo" loading="lazy" />}
              <h3>{s.name}</h3>
              <p className="upcoming-set-card__date">
                {Number.isFinite(releaseTs) ? new Date(releaseTs).toLocaleDateString(undefined, { month: 'long', day: 'numeric', year: 'numeric' }) : s.releaseDate}
              </p>
              <Countdown ms={ms} />
              <Link to={`/pre-orders?set=${encodeURIComponent(s.id)}`} className="upcoming-set-card__cta">
                Reserve now →
              </Link>
            </article>
          );
        })}
      </div>
    </section>
  );
}

function Countdown({ ms }) {
  if (ms <= 0) return <span className="upcoming-set-card__countdown">Released</span>;
  const s = Math.floor(ms / 1000);
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  return (
    <div className="upcoming-set-card__countdown">
      <span><strong>{d}</strong>d</span>
      <span><strong>{h}</strong>h</span>
      <span><strong>{m}</strong>m</span>
    </div>
  );
}
